import { Component, Inject, OnInit, Renderer2, DOCUMENT } from "@angular/core";
import { NgZone } from '@angular/core';
import { Router } from "@angular/router";
import { catchError } from "rxjs/operators";
import { BrandingService, CompanyBranding, CompanyColorSchemaEnum, MetaService } from "common";
import { Title } from "@angular/platform-browser";
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { EMPTY } from "rxjs";

@UntilDestroy()
@Component({
    selector: "ifp-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.css"],
    standalone: false
})
export class AppComponent implements OnInit {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private router: Router,
    private titleService: Title,
    private metaService: MetaService,
    private brandingService: BrandingService,
    private ngZone: NgZone
  ) { }
  ngOnInit(): void {
    this.brandingService.getBranding$()
    .pipe(
      untilDestroyed(this),
      catchError((error) => {
        console.error(error);
        return EMPTY;
      })
    ).subscribe(data => {
      this.initBrandingTheme(data);
      this.setDOMElements(data);
    });
    this.ngZone.runOutsideAngular(() => {
      const script = document.createElement('script');
      script.src = 'https://assets.decisionlogic.com/cdn/widgetui/widgetUI.js';
      document.head.appendChild(script);
    })
  }

  private initBrandingTheme(brandingData: CompanyBranding) {
    if (brandingData?.colorSchema === CompanyColorSchemaEnum.LevelEsq) {
      this.renderer.setAttribute(
        this.document.body,
        "class",
        "theme-level-esq"
      );
    }
  }

  private setDOMElements(brandingData: CompanyBranding): void {
    if (this.router.url === "/sign-in")
      this.titleService.setTitle(
        `Business Financing | ${
          brandingData?.dba ?? "Idea Financial"
        } Sign In`
      );
    else
      this.titleService.setTitle(
        `Business Financing | ${brandingData?.dba ?? "Idea Financial"}`
      );

    this.metaService.createMetaTag(
      "description",
      `Welcome to your ${brandingData?.dba} account. You can access information about your business with us here.`
    );
    this.metaService.createAlternateURL(
      brandingData?.domains?.length
        ? brandingData?.domains[2]
        : "https://portal.ideafinancial.com"
    );
  }
}
